"use client"

import Carousel from "@/components/common/Carousel"
import Link from "@/components/common/Typography/Link"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTour } from "@/hooks/tour/useTour"
import { faChevronLeft, faChevronRight, faFileDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Col, Divider, Row, Tabs, theme } from "antd"
import Flickity from "flickity"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

export const breakdownChars = [
  "❖", "", "", "✓", "", "•", "▪", "", "❖", "✓",
  "•","◦","○","●","▪","▫","■","□","◆","◇","★","☆","✦","✧","❖","✪","✫","✚","✱","✲","✳","✵","✸","✹","✺","➤","➥","➧","➨","➩","➪","➫","➬","➭","➮","➯","➱","→","⇒","➔","➢","➣","✦","✔","✖","☑","☐","☒","※"
]

const TourContentConditions = () => {
  const [tab, setTab] = useState<any>('')
  const { tour: { data: tour } } = useTour()
  const isDesktop = useIsDesktop()
  const token = theme.useToken().token
  const refCarousel = useRef<Flickity>(null)
  const { t } = useTranslation()

  useEffect(() => {
    if (!tab && !!tour.contentConditions?.length) {
      setTab(tour.contentConditions[0].title)
    }
  }, [tab, tour.contentConditions])

  const contentConditions = (tour.contentConditions || []).filter(cond => !!cond.description)
  const fileUploads = (tour.fileUploads || [])
  const pdfFiles = fileUploads.filter(file => file.path.endsWith(".pdf"))
  const docFiles = fileUploads.filter(file => !file.path.endsWith(".pdf"))
  const passedFile = pdfFiles.length > 0 ? pdfFiles : docFiles
  return (
    <Card
      style={isDesktop ? {} : { borderRadius: 0 }}
      styles={{
        body: {
          paddingInline: 0,
          paddingBlock: '1.2rem'
        }
      }}
    >
      <Row justify='space-between' align='middle' className="passenger__form--row">
        <Col>
          <Title level={4} style={{ margin: 0 }}>
            {t("tour.info_note")}
          </Title>
        </Col>
        {!!passedFile.length && (
          <Col>
            <Row gutter={10}>
              {passedFile
                .map((file, idx) => {
                  return (
                    <Col>
                      <Link download href={file.path}><FontAwesomeIcon icon={faFileDownload} /> {t("tour.tour_detail")} {idx + 1}</Link>
                    </Col>
                  )
                })}
            </Row>

          </Col>
        )}
      </Row>
      {!!contentConditions.length && (
        <Row style={{ marginTop: '1rem' }} align={'middle'} gutter={[0, 10]} className="passenger__form--row">
          <Col span={24}>
            <Row align='middle' gutter={5} wrap={false}>
              <Col>
                <Button
                  onClick={() => refCarousel.current?.previous()}
                  size='small'
                  type='text'
                  icon={<FontAwesomeIcon icon={faChevronLeft} />}
                />
              </Col>
              <Col flex={1}>
                <Carousel
                  flickityRef={curr => { refCarousel.current = curr; }}
                  className="carousel-main"
                  options={{
                    pageDots: false,
                    cellAlign: "left",
                    contain: true,
                    draggable: true,
                    prevNextButtons: false,
                    adaptiveHeight: true,
                  }}
                >
                  {(tour.contentConditions || []).map(({ title, description }, idx) => {
                    return (
                      <div
                        key={title}
                        className="flickity-container flickity-cell"
                        style={{
                          padding: 0,
                          margin: 0,
                          marginRight: 5,
                          borderRadius: 8
                        }}
                      >
                        <Button
                          onClick={() => setTab(title)}
                          style={{
                            color: tab === title ? token.colorPrimaryText : undefined,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            // borderColor: token.colorBorder,
                            borderTopColor: token.colorBorder,
                            borderRightColor: token.colorBorder,
                            borderLeftColor: token.colorBorder,
                            borderBottomColor: tab === title ? 'white' : token.colorBorder,
                            backgroundColor: tab === title ? undefined : 'rgba(0,0,0,0.02)'
                          }}
                        >
                          {title}
                        </Button>
                      </div>
                    );
                  })}
                </Carousel>
                <Divider style={{ margin: 0, marginTop: -1 }} />
              </Col>
              <Col>
                <Button
                  onClick={() => refCarousel.current?.next()}
                  size='small'
                  type='text'
                  icon={<FontAwesomeIcon icon={faChevronRight} />}
                />
              </Col>
            </Row>

          </Col>

          <Col span={24}>
            <Tabs
              activeKey={tab}
              renderTabBar={() => <></>}
              items={(tour.contentConditions || []).map(({ title, description }) => {
                return {
                  key: title,
                  label: title,
                  children: (
                    <Row>
                      <Col className="tour-detail__condition--content" span={24} dangerouslySetInnerHTML={{ __html: breakdownChars.reduce((str, char, idx) => str.replace(char, str[0] === char ? "– " : "").replaceAll(char, "<br><br> –"), description) }} />
                    </Row>
                  )
                }
              })}
            />
          </Col>
        </Row>
      )}
    </Card>
  )
}

export default TourContentConditions